import _extends from '../../../node_modules/@babel/runtime/helpers/esm/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import { makeStyles, Box, Typography } from '@material-ui/core';
import clsx from 'clsx';
import PropTypes__default from 'prop-types';
import React__default, { useRef, useEffect } from 'react';
import Slider from 'react-slick';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import CustomIconButton from '../../widgets/button/custom-icon-button/CustomIconButton.js';
import ArrowBackIcon from '../../widgets/streamline-icon/ArrowBackIcon.js';
import ArrowForwardIcon from '../../widgets/streamline-icon/ArrowForwardIcon.js';
import HeroCard from '../../widgets/hero-card/HeroCard.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = makeStyles(function (theme) {
  return {
    sliderContainer: {
      "& .slick-track": {
        display: "flex",
        paddingBottom: theme.spacing(3)
      },
      "& .slick-slide": {
        height: "auto",
        "& > div": {
          height: "100%",
          marginRight: "8px"
        }
      }
    },
    btn: {
      color: theme.palette.text.black,
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.main
      },
      "& i": {
        padding: 0,
        fontSize: theme.spacing(2.5)
      },
      "&:first-of-type": {
        marginRight: theme.spacing(2)
      }
    },
    btnSize: {
      width: theme.spacing(6),
      height: theme.spacing(6)
    },
    mr2: {
      marginRight: theme.spacing(2)
    },
    arrow: {
      color: theme.palette.text.black
    },
    infoMessage: _objectSpread({}, theme.typography.infoMessage)
  };
});
var HeroCardSlider = function HeroCardSlider(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    titleTextColor = _ref.titleTextColor,
    subtitleTextColor = _ref.subtitleTextColor,
    cards = _ref.cards,
    sliderOpts = _ref.sliderOpts,
    _onButtonClick = _ref.onButtonClick,
    onVisibleSliderCards = _ref.onVisibleSliderCards;
  var classes = useStyles();
  var sliderRef = useRef();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  useEffect(function () {
    if (isExtraSmallScreen()) {
      onVisibleSliderCards(cards[0]);
    } else {
      onVisibleSliderCards(cards.slice(0, 2));
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(Box, null, title && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h3",
    style: {
      color: titleTextColor
    }
  }, title), subtitle && /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.infoMessage,
    style: {
      color: subtitleTextColor
    }
  }, subtitle), (cards === null || cards === void 0 ? void 0 : cards.length) > 0 && /*#__PURE__*/React__default.createElement(Box, {
    mt: 4
  }, /*#__PURE__*/React__default.createElement(Slider, _extends({}, _objectSpread(_objectSpread({}, sliderOpts), {}, {
    slidesToShow: isExtraSmallScreen() || (cards === null || cards === void 0 ? void 0 : cards.length) === 1 ? 1 : 2
  }), {
    ref: sliderRef,
    className: classes.sliderContainer,
    beforeChange: function beforeChange(_oldIndex, newIndex) {
      if (isExtraSmallScreen()) {
        onVisibleSliderCards(cards[newIndex]);
      } else {
        onVisibleSliderCards(cards.slice(newIndex, newIndex + 2));
      }
    }
  }), cards.map(function (card, index) {
    return /*#__PURE__*/React__default.createElement(HeroCard, _extends({
      key: index
    }, card, {
      onButtonClick: function onButtonClick() {
        return _onButtonClick(card);
      }
    }));
  }))), (isExtraSmallScreen() ? (cards === null || cards === void 0 ? void 0 : cards.length) > 1 : (cards === null || cards === void 0 ? void 0 : cards.length) > 2) && /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    justifyContent: isExtraSmallScreen() ? "center" : "end",
    marginRight: 1
  }, /*#__PURE__*/React__default.createElement(CustomIconButton, {
    className: clsx(classes.btn, classes.mr2, classes.btnSize),
    disableRipple: true,
    onClick: function onClick() {
      return sliderRef.current.slickPrev();
    }
  }, /*#__PURE__*/React__default.createElement(ArrowBackIcon, {
    className: classes.arrow
  })), /*#__PURE__*/React__default.createElement(CustomIconButton, {
    className: clsx(classes.btn, classes.btnSize),
    disableRipple: true,
    onClick: function onClick() {
      return sliderRef.current.slickNext();
    }
  }, /*#__PURE__*/React__default.createElement(ArrowForwardIcon, {
    className: classes.arrow
  }))));
};
var heroCardInterface = {
  bgColor: PropTypes__default.string,
  bgImageUrl: PropTypes__default.string,
  bgImagePosition: PropTypes__default.string,
  bgImageSize: PropTypes__default.string,
  hint: PropTypes__default.string,
  title: PropTypes__default.string,
  textColor: PropTypes__default.string,
  actionButtonLabel: PropTypes__default.string
};
HeroCardSlider.propTypes = {
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  titleTextColor: PropTypes__default.string,
  subtitleTextColor: PropTypes__default.string,
  cards: PropTypes__default.arrayOf(PropTypes__default.shape(heroCardInterface)),
  sliderOpts: PropTypes__default.object,
  onButtonClick: PropTypes__default.func,
  onVisibleSliderCards: PropTypes__default.func
};
HeroCardSlider.defaultProps = {
  sliderOpts: {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToScroll: 1
  }
};

export { HeroCardSlider as default, heroCardInterface };
//# sourceMappingURL=HeroCardSlider.js.map
